<template>
    <div>
        <div class="search-layout">
            <el-input placeholder="请输入服务名称" style="width: 225px;" class="mr10 mb10" v-model="name">
                <template slot="prepend">服务名称</template>
            </el-input>
            <el-button class="el-search-btn" type="primary" icon="el-icon-search" @click="getServcs()">搜索</el-button>
        </div>
        <el-table :data="servcList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
            <el-table-column width="55">
                <template slot-scope="rows">
                    <div class="copy-radio" :class="{'circle' : servcId != null && servcId == rows.row.id}">
                        <div class="circle-dot"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="服务名称" align="center"></el-table-column>
            <!--<el-table-column prop="title" label="服务标题" align="center"></el-table-column>-->
            <el-table-column label="服务类型" align="left" width="120" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{servcTypeMap[rows.row.type]}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="catName" label="服务分类" align="center"></el-table-column>
        </el-table>
        <div class="block pagination-layout" v-if="totalCount > 10">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import servcApi from '../../api/servc'

    export default{
        name: 'swb-servc-for-selected',
        desc: '单选servc',
        props: {
            goodsCatId: {
                type: Number,
                default: null
            },
            servcType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                servcList: [],
                selectServc: null,
                servcId: null,
                name: null,
                servcTypeMap: {},
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.servcTypeMap = getEnumMap('servcType', 'value2text');
            //
            this.getServcs();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcs();
            },
            //
            getServcs: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                if(!Utils.isNoB(self.goodsCatId)) {
                    filterItems.goodsCatId = self.goodsCatId;
                }
                if(!Utils.isNoB(self.servcType)) {
                    filterItems.type = self.servcType;
                }
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                servcApi.getServcList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.servcList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选中服务
            handleCurrentChange: function (val) {
                this.servcId = val.id;
                this.selectServc = Utils.merge({}, val);
            },
            //
            getDlgResult: function () {
                let self = this;
                let servcId = self.servcId;
                let result = {};
                if(!Utils.isNoB(servcId)) {
                    result.type = 'info';
                    result.data = this.selectServc;
                } else {
                    result.type = 'warn';
                    MsgBox.warning('请选择服务');
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/servc/ServcForSelected.vue